import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <div className="footer-style">
        This was made by <a href="https://github.com/Feben9" target="_blank" rel="noreferrer"> Feben</a>, code is
        open-sourced on <a href="https://github.com/Feben9/Weather-React" target="_blank" rel="noreferrer">
           Github</a> and hosted on <a href="https://github.com/Feben9">Netlify</a>
      </div>
    );
}